import Joi from "joi";

// Create semester validation
export const createSemesterValidation = (req: any, res: any, next: any) => {
  const schema = Joi.object({
    semesterName: Joi.string().trim().min(2).max(100).required().messages({
      "string.min": "Semester name must be at least 2 characters",
      "string.max": "Semester name cannot exceed 100 characters",
      "any.required": "Semester name is required",
    }),
    startDate: Joi.date().iso().required().messages({
      "date.base": "Start date must be a valid date",
      "date.format": "Start date must be in ISO format (YYYY-MM-DD)",
      "any.required": "Start date is required",
    }),
    endDate: Joi.date()
      .iso()
      .greater(Joi.ref("startDate"))
      .required()
      .messages({
        "date.base": "End date must be a valid date",
        "date.format": "End date must be in ISO format (YYYY-MM-DD)",
        "date.greater": "End date must be after start date",
        "any.required": "End date is required",
      }),
    academicYear: Joi.string()
      .trim()
      .min(4)
      .max(20)
      .pattern(/^\d{4}(-\d{4})?$/)
      .optional()
      .messages({
        "string.pattern.base":
          "Academic year must be in format YYYY or YYYY-YYYY",
        "string.min": "Academic year must be at least 4 characters",
        "string.max": "Academic year cannot exceed 20 characters",
      }),
    description: Joi.string().trim().max(500).optional().messages({
      "string.max": "Description cannot exceed 500 characters",
    }),
  });

  const { error, value } = schema.validate(req.body);
  if (error) {
    return res.status(400).json({
      success: false,
      message: "Validation failed",
      error: error.details[0].message,
    });
  }

  req.body = value;
  next();
};

// Update semester validation
export const updateSemesterValidation = (req: any, res: any, next: any) => {
  const schema = Joi.object({
    semesterName: Joi.string().trim().min(2).max(100).optional().messages({
      "string.min": "Semester name must be at least 2 characters",
      "string.max": "Semester name cannot exceed 100 characters",
    }),
    startDate: Joi.date().iso().optional().messages({
      "date.base": "Start date must be a valid date",
      "date.format": "Start date must be in ISO format (YYYY-MM-DD)",
    }),
    endDate: Joi.date().iso().optional().messages({
      "date.base": "End date must be a valid date",
      "date.format": "End date must be in ISO format (YYYY-MM-DD)",
    }),
    academicYear: Joi.string()
      .trim()
      .min(4)
      .max(20)
      .pattern(/^\d{4}(-\d{4})?$/)
      .optional()
      .messages({
        "string.pattern.base":
          "Academic year must be in format YYYY or YYYY-YYYY",
        "string.min": "Academic year must be at least 4 characters",
        "string.max": "Academic year cannot exceed 20 characters",
      }),
    description: Joi.string().trim().max(500).optional().messages({
      "string.max": "Description cannot exceed 500 characters",
    }),
    status: Joi.string()
      .valid("active", "inactive", "completed")
      .optional()
      .messages({
        "any.only": "Status must be one of: active, inactive, completed",
      }),
    isActive: Joi.boolean().optional(),
  })
    .custom((value, helpers) => {
      // Custom validation for date range when both dates are provided
      if (value.startDate && value.endDate) {
        const startDate = new Date(value.startDate);
        const endDate = new Date(value.endDate);

        if (endDate <= startDate) {
          return helpers.error("custom.dateRange");
        }
      }
      return value;
    })
    .messages({
      "custom.dateRange": "End date must be after start date",
    });

  const { error, value } = schema.validate(req.body);
  if (error) {
    return res.status(400).json({
      success: false,
      message: "Validation failed",
      error: error.details[0].message,
    });
  }

  req.body = value;
  next();
};

// Semester status validation
export const semesterStatusValidation = (req: any, res: any, next: any) => {
  const schema = Joi.object({
    status: Joi.string()
      .valid("active", "inactive", "completed")
      .required()
      .messages({
        "any.only": "Status must be one of: active, inactive, completed",
        "any.required": "Status is required",
      }),
  });

  const { error, value } = schema.validate(req.body);
  if (error) {
    return res.status(400).json({
      success: false,
      message: "Validation failed",
      error: error.details[0].message,
    });
  }

  req.body = value;
  next();
};

// Academic year validation
export const academicYearValidation = (req: any, res: any, next: any) => {
  const schema = Joi.object({
    academicYear: Joi.string()
      .trim()
      .min(4)
      .max(20)
      .pattern(/^\d{4}(-\d{4})?$/)
      .required()
      .messages({
        "string.pattern.base":
          "Academic year must be in format YYYY or YYYY-YYYY",
        "string.min": "Academic year must be at least 4 characters",
        "string.max": "Academic year cannot exceed 20 characters",
        "any.required": "Academic year is required",
      }),
  });

  const { error, value } = schema.validate(req.query);
  if (error) {
    return res.status(400).json({
      success: false,
      message: "Validation failed",
      error: error.details[0].message,
    });
  }

  req.query = value;
  next();
};
